define('views/widgets/currency',['require','mediator','views/base/view','views/base/collection','text!templates/widgets/currency/index.ejs','text!templates/widgets/currency/item.ejs','text!templates/widgets/currency/list.ejs'],function(require) {
    'use strict';

    var mediator = require('mediator'),
        View = require('views/base/view'),
        CollectionView = require('views/base/collection'),
        template = require('text!templates/widgets/currency/index.ejs'),
        templateItem = require('text!templates/widgets/currency/item.ejs'),
        templateList = require('text!templates/widgets/currency/list.ejs');

    var CurrencyItemView = View.extend({
        tagName: 'li',
        className: 'menu-item',
        template: templateItem,
        listen: {
            'change:value model': 'render'
        },
        constructor: function() {
            View.apply(this, arguments);
            this.delegate('click', this.onClick);
        },
        onClick: function() {
            this.publishEvent('currencyWidgetRemoveHover');
        }
    });

    var CurrencyCollectionView = CollectionView.extend({
        itemView: CurrencyItemView,
        autoRender: true,
        tagName: 'ul',
        className: 'nav nav-list collapse-area',
        // animationDuration: 0,
        loadingSelector: '.loading',
        template: templateList,
        addCollectionListeners: function() {
            this.listenTo(this.collection, 'add', this.itemAdded);
            this.listenTo(this.collection, 'remove', this.itemRemoved);
            return this.listenTo(this.collection, 'reset', this.itemsReset);
        }
    });

    var CurrencyWidgetView = View.extend({
        autoRender: true,
        className: 'currency-widget menu-item hover-active',
        tagName: 'li',
        template: template,
        attributes: {
            'style': 'opacity: 1; display: list-item;'
        },
        listen: {
            'currencyWidgetRemoveHover mediator': 'removeHover'
        },
        constructor: function() {
            View.apply(this, arguments);
            this.delegate('click', 'a:first', this.onClick);
            this.listenTo(mediator.userSettings, 'change:currencyWidgetExpanded', this.updateExpanded);
        },
        render: function() {
            View.prototype.render.apply(this, arguments);

            var view = new CurrencyCollectionView({ collection: this.model.items, container: this.el });
            this.subview('items', view);

            this.updateExpanded();
        },
        onClick: function() {
            var settings = mediator.userSettings;

            settings.set('currencyWidgetExpanded', !settings.get('currencyWidgetExpanded'));
            mediator.userSettings.save();
        },
        updateExpanded: function() {
            var settings = mediator.userSettings;

            this.$el[settings.get('currencyWidgetExpanded') ? 'removeClass' : 'addClass']('rolled-up');
        },
        removeHover: function() {
            var _this = this;
            this.$el.removeClass('hover-active');
            setTimeout(function() {
                _this.$el.addClass('hover-active');
            }, 500);
        }
    });

    return CurrencyWidgetView;
});

